import i18n from 'i18n/config';

import { store } from 'redux/store';
import { Board, Society, User } from 'types';

import { addAlert } from 'modules/_shared/redux/alertActions';
import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';
import { deleteBoard as deleteBoardAction } from 'modules/boards/redux/boardActions';

import eventTypes from 'constants/eventTypes';
import trackEvent from 'utils/trackEvent';
import asyncActionSwal from 'utils/asyncActionSwal';
import successSwal from 'utils/successSwal';
import errorSwal from 'utils/errorSwal';

type DeleteBoardProps = {
  board: Board;
  user: User;
  actualSociety: Society;
  mixpanel: any;
};

export const deleteBoard = async (params: DeleteBoardProps) => {
  const { board, user, actualSociety, mixpanel } = params;

  asyncActionSwal({
    swalTitle: i18n.t('AreYouSureAboutDelBoard'),
    swalElementName: board.name,
    swalInfoText: i18n.t('ThisProcedureCantUndo'),
    swalConfirmButtonText: i18n.t('OkDelete'),
    callback: async () => {
      try {
        try {
          await store.dispatch(deleteBoardAction(board._id));

          const currentEvent = eventTypes.DELETE_BOARD;
          trackEvent(mixpanel, currentEvent, {
            userId: user?.['_id'],
            userName: user?.name,
            userEmail: user?.email,
            societyId: actualSociety?.['_id'],
            societyName: actualSociety?.name,
            operation: currentEvent,
          });
        } catch (error) {
          store.dispatch(addAlert(alertBodyTypes.ERROR_DELETING_BOARD));
        }
        successSwal(i18n.t('BoardRemovedSuccessfully'));
      } catch (error) {
        errorSwal(i18n.t('ErrorRemovingBoard'));
      }
    },
  });
};
